import React, { FC } from 'react';
import styled from 'styled-components';
import * as RadixSeparator from '@radix-ui/react-separator';

import { getCurrentTheme } from '@providers/EdnaProvider';

import { SeparatorProps } from './types';

const StyledSeparator = styled(RadixSeparator.Root)<{
  $width: string;
  $height: string;
  $color: string;
  $margin: string;
}>`
  width: ${(props) => props.$width};
  height: ${(props) => props.$height};
  background-color: ${(props) => props.$color};
  margin: ${(props) => props.$margin};
`;

const Separator: FC<SeparatorProps> = ({
  orientation = 'horizontal',
  width,
  height,
  margin = '0',
  color,
  className,
}) => {
  const { colors } = getCurrentTheme();
  const isHorizontal = orientation === 'horizontal';

  return (
    <StyledSeparator
      orientation={orientation}
      $width={width ?? (isHorizontal ? '100%' : '1px')}
      // setting height to 100% does not work for vertical separators so we set a default height of 30px
      $height={height ?? (isHorizontal ? '1px' : '30px')}
      $color={color || colors.grey100}
      $margin={margin}
      className={className}
    />
  );
};

export default Separator;
